import Fuse from "fuse.js";
import { makeQuery } from "src/queries/makeQuery";
import type { SearchEntity } from "./search.types";

const selectFuse = (entities: SearchEntity[]) => {
  return new Fuse(entities, {
    keys: ["name"],
    threshold: 0.6,
    includeScore: true,
    includeMatches: true,
    minMatchCharLength: 3,
    ignoreLocation: true,
  });
};

export const useSearchEntities = makeQuery<SearchEntity[], Fuse<SearchEntity>>(
  "/api/search/entities",
  { select: selectFuse }
);
